import { useSettingsStore } from '@/features/settings/stores/settings.store';
import { logger } from '@/features/help/utils/logger';

/**
 * Document Upload Settings component
 * Allows brokers to control whether additional signers can upload documents
 */
export const DocumentUploadSettings = () => {
  const {
    allowAdditionalSignerDocUpload,
    updateAllowAdditionalSignerDocUpload,
    isSavingDocUpload,
  } = useSettingsStore();

  /**
   * Handles toggling the additional signer document upload setting
   * Uses dedicated endpoint to avoid coupling with other notification settings
   */
  const handleToggleAdditionalSignerDocUpload = async () => {
    const newValue = !allowAdditionalSignerDocUpload;
    logger.info('DocumentUploadSettings', 'Toggling additional signer document upload setting', {
      currentValue: allowAdditionalSignerDocUpload,
      newValue,
    });
    await updateAllowAdditionalSignerDocUpload(newValue);
  };

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Document Upload Settings</h2>

      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-sm font-medium text-gray-900">
            Allow Additional Signers to Upload Documents
          </h3>
          <p className="text-sm text-gray-500">
            When enabled, additional signers will see the document upload page after completing
            their portion of the application.
          </p>
        </div>
        <button
          type="button"
          onClick={handleToggleAdditionalSignerDocUpload}
          disabled={isSavingDocUpload}
          className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 ${
            allowAdditionalSignerDocUpload ? 'bg-blue-600' : 'bg-gray-200'
          }`}
          role="switch"
          aria-checked={allowAdditionalSignerDocUpload}
        >
          <span
            className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
              allowAdditionalSignerDocUpload ? 'translate-x-5' : 'translate-x-0'
            }`}
          />
        </button>
      </div>
    </div>
  );
};

